/// A File to hold the one "true" Three.js import.
import * as T from 'three';
export default T;
